var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isOpen
    ? _c("modal", {
        attrs: { maxWidth: "450px" },
        on: {
          "hide-modal": function ($event) {
            return _vm.hideModal()
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function () {
                return [
                  _c("div", { staticClass: "relative w-full" }, [
                    _c(
                      "div",
                      { staticClass: "header" },
                      [
                        _c("h3", { staticClass: "text-center" }, [
                          _vm._v("Microdeposit Agreement"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "micro-wrapper" }, [
                          _c("h5", [
                            _c(
                              "span",
                              { staticClass: "text-red-600 text-center" },
                              [_vm._v("IMPORTANT:")]
                            ),
                            _vm._v(
                              " Order incomplete until microdeposit verified."
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        !_vm.showWhy
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "cursor-pointer text-2xl text-center mt-1/2 blue-text leading-snug underline",
                                on: {
                                  click: function ($event) {
                                    _vm.showWhy = !_vm.showWhy
                                  },
                                },
                              },
                              [_vm._v("Why must I do this?")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showWhy
                          ? _c(
                              "p",
                              {
                                staticClass: "mt-1 dark-blue-text leading-snug",
                              },
                              [
                                _vm._v(
                                  "Per NACHA's ACH regulations, account ownership verification is now required."
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "mt-1/2 dark-blue-text leading-snug" },
                          [
                            _vm._v(
                              "Follow these steps to complete verification:"
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ol",
                          { staticClass: "list-decimal pl-1 leading-snug" },
                          [
                            _c("li", [
                              _vm._v(
                                'Wait 24-48 hours to recieve an email from Stripe with "Verify your bank account for Samsara Inc." in the subject line'
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                'Click the "Verify deposit" link in the email and follow steps to enter microdeposit verification code'
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "good-email-wrapper" }, [
                          _c(
                            "p",
                            { staticClass: "mt-0 dark-blue-text leading-snug" },
                            [
                              _vm._v("The email will be sent to: "),
                              _c("span", { staticClass: "bold" }, [
                                _vm._v(_vm._s(_vm.shipping.email)),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "mt-1 dark-blue-text leading-snug text-xl",
                          },
                          [
                            _vm._v(
                              'By selecting "Proceed with Microdeposit" you agree to complete the verification process. Order will be incomplete until then.'
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("vButton", {
                          attrs: {
                            position: "center",
                            mobile: "12",
                            tablet: "12",
                            desktop: "12",
                            styling: "primary text-lg md:text-xl",
                            wrapperStyling: "mt-1 !mb-1/2 p-0",
                            height: "42px",
                            disabled: false,
                          },
                          on: { onClickEvent: _vm.submitPaymentData },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "content",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n                      Proceed with Microdeposit\n                  "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            1256320406
                          ),
                        }),
                        _vm._v(" "),
                        _c("vButton", {
                          attrs: {
                            position: "center",
                            mobile: "12",
                            tablet: "12",
                            desktop: "12",
                            styling: "blue-text underline text-sm md:text-xl",
                            wrapperStyling: "!mt-0 !mb-0",
                            height: "42px",
                            disabled: false,
                          },
                          on: { onClickEvent: _vm.toReview },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "content",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n                      Choose another method\n                  "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            1077747645
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          2235027827
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }